var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"story-paragraph"},[_c('div',{staticClass:"font-base mb-3 text-block"},[(_vm.$slots.title)?_c('h3',{staticClass:"d-inline-block mb-1"},[_vm._t("title")],2):_vm._e(),_c('div',[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }